import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {IDrug, IDrugFormulation} from '../../entities/Drug/Drug.ts';

export class DrugApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Drugs`;

    public static apiUrls = {
        getDrugFormulation: `${DrugApi.baseApiUrl}/:id/Formulations`,
        getDrugSearch: `${DrugApi.baseApiUrl}/Search`,
    };

    public static async getDrugFormulations(id: string): Promise<IDrugFormulation> {
        return this.sendApiRequest<IDrugFormulation>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getDrugFormulation,
            data: undefined,
            id: id
        });
    }

    public static async getDrugsSearch(search: string): Promise<IDrug[]> {
        return this.sendApiRequest<IDrug[]>({
            method: HttpMethodEnum.GET,
            path: `${this.apiUrls.getDrugSearch}/${search}`,
        });
    }
}
